import React from "react";
import { ClientColyseusContext } from "../../contexts/ClientColyseusContext.js";
import Button from "../Button.js";
import { withRouter } from "react-router-dom";

class FormCreateRoom extends React.Component {
  static contextType = ClientColyseusContext;

  constructor(props) {
    super(props);
    this.state = {
      Courses: [],
      course: null,
      name: "My room",
      mod: "speed_duel",
      maxPlayer: 2,
      pwd: "",
      nbQuestions: 5,
      isWaiting: false, // Add a state to track if the room is waiting
    };
  }

  componentDidMount() {
    fetch(process.env.REACT_APP_API_URL + "/course")
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          Courses: res.courses,
          course: res.courses[0].course_title,
          course_id: res.courses[0].course_id,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleCourse = (e) => {
    this.state.Courses.map((course) => {
      if (course.course_title === e.target.value)
        this.setState({ course_id: course.course_id, course: e.target.value });
    });
  };

  handleMod = (e) => {
    this.setState({ mod: e.target.value });
  };

  handleNbQuestions = (e) => {
    this.setState({ nbQuestions: e.target.value });
  };

  handleMaxPlayer = (e) => {
    this.setState({ maxPlayer: e.target.value });
  };

  handleName = (e) => {
    this.setState({ name: e.target.value });
  };

  handlePwd = (e) => {
    this.setState({ pwd: e.target.value });
  };

  handleTime = e => {
    this.setState({TimePerQuestion:e.target.value});
}

  handleCreateRoom = () => {
    const {
      mod,
      name,
      pwd,
      course,
      course_id,
      nbQuestions,
      maxPlayer,
      TimePerQuestion
    } = this.state;
  
     // Log the context to see what is available
  console.log(this.context);

  // Set the room as waiting
  this.setState({ isWaiting: true });
  
  this.context.createRoom(
    mod,
    name,
    pwd,
    course,
    course_id,
    nbQuestions,
    maxPlayer,
    TimePerQuestion
  );
  console.log('course_id',course_id)
  console.log('course',course_id)
  // Set the room as waiting
  this.setState({ isWaiting: true });
};
  

  render() {
    return (
      <div className="container mt-5" style={{ marginTop: "100px"}}>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Room Name:</label>
          <div className="col-sm-10">
            <input type="text" className="form-control" defaultValue={this.state.name} onChange={this.handleName} />
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Course:</label>
          <div className="col-sm-10">
            <select className="form-select" onChange={this.handleCourse}>
              {this.state.Courses.map((course, index) => (
                <option key={index} value={course.course_title}>{course.course_title}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Max Player:</label>
          <div className="col-sm-10">
            <input type="number" className="form-control" min="2" defaultValue="2" onChange={this.handleMaxPlayer} />
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Number of questions:</label>
          <div className="col-sm-10">
            <select className="form-select" defaultValue="5" onChange={this.handleNbQuestions}>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="40">40</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Duration per question (in seconds):</label>
          <div className="col-sm-10">
            <select className="form-select" defaultValue="20" onChange={this.handleTime}>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="15">15</option>
              <option value="20">20</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <label className="col-sm-2 col-form-label">Mod:</label>
          <div className="col-sm-10">
            <select className="form-select" defaultValue="speed_duel" onChange={this.handleMod}>
              <option value="speed_duel">Speed Duel</option>
              <option value="my_room">My Room</option>
              <option value="evaluation">Evaluation</option>
            </select>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-10 offset-sm-2">
            <button className="btn btn-primary" onClick={this.handleCreateRoom} disabled={this.state.isWaiting}>
              Create Room
            </button>
          </div>
        </div>
      </div>
    );
    
  }
}

export default withRouter(FormCreateRoom);


